export function forceNumberArray(value: string | number[]) {
  if (Array.isArray(value)) {
    return value;
  }
  return ((value as unknown) as string)
    .split(",")
    .filter((v) => !!v)
    .map((v) => parseInt(v, 10));
}
